<template>
  <section class="section-wrapp">
    <Breadcrumbs v-if="breadcrumbsData !== null" v-bind:parameters="breadcrumbsData"></Breadcrumbs>
    <InverterProduction></InverterProduction>
    <section class="section-graph">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <PowerForecast></PowerForecast>
          </div>
        </div>
      </div>
    </section>
    <section class="section-graph">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="device-graph-table style">
              <div v-if="haveData" class="device-graph style" style="color:#fff">
                <highcharts :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-graph">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="analytics-table-text">
              <div class="analytics-table-text__text">Production forecast</div>
              <div class="analytics-table-text__buttons">
                <a href="#" @click.prevent="downloadCSV" class="csv">Download csv</a>
                <a href="#" @click.prevent="downloadXML" class="xml">Download xml</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="device-graph-table style">
              <div class="device-table-wrapp">
                <div v-if="values !== null" class="device-table scroll-without-bg scroll-small-size">
                  <table class="device-table">
                    <tr>
                      <th><span>Time</span></th>
                      <th><span>Actual, kWH</span></th>
                      <th><span>Forecast, kWH</span></th>
                      <th><span>Accuracy, %</span></th>
                    </tr>
                    <tr :key="data.time" v-for="data in tableData" :style="{backgroundColor : (data.isDay) ? '#f36f37' : null}">
                      <td><span>Time</span><b></b><i>{{ data.time }}</i></td>
                      <td><span>Actual, kWH</span><b></b><i>{{ data.actual }}</i></td>
                      <td><span>Forecast, kWH</span><b></b><i>{{ data.forecast }}</i></td>
                      <td><span>Accuracy, %</span><b></b><i>{{ data.percent }}</i></td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>

import Breadcrumbs from '@/components/Breadcrumbs.vue'
import PowerForecast from '@/components/analytics/PowerForecast'
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import '@/../node_modules/flatpickr/dist/themes/dark.css'
import '@/assets/css/js-datapicer.scss'
import graphConfigs from '@/components/graphConfigs'
import moment from 'moment'
import stationApi from '@/api/station'
import InverterProduction from '@/components/analytics/InverterProduction'

stockInit(Highcharts)

export default {
  name: 'Analytics',
  mixins: [graphConfigs],
  components: {
    Breadcrumbs,
    'highcharts': Chart,
    PowerForecast,
    InverterProduction
  },
  data () {
    let now = moment().add(2, 'hours')

    return {
      values: null,
      isActive: false,
      breadcrumbsData: null,
      stationId: null,
      pageTitle: {
        name: 'Афанасиевка',
        power: ''
      },
      haveData: false,
      chartOptions: {
        title: {
          text: 'Production forecast',
          style:
            {
              'color': '#fff',
              'fontSize': '16px'
            }
        },
        rangeSelector: {
          selected: 1,
          buttons: [{
            type: 'day',
            count: 1,
            text: 'Day'
          },
          {
            type: 'all',
            text: 'All'
          }]
        },
        yAxis: [
          {
            title: {
              style: {
                color: '#fff'
              }
            },
            labels: {
              style: {
                color: '#fff'
              }
            },
            gridLineColor: '#595c5e'
          }
        ],
        xAxis: {
          labels: {
            style: {
              color: '#fff'
            }
          },
          plotLines: [{
            value: now.valueOf(),
            dashStyle: 'dash',
            width: 2,
            color: '#f36f37'
          }]
        },
        chart: {
          marginLeft: 25,
          marginRight: 25,
          type: 'column'
        },
        series: [
          {
            data: [],
            name: 'Actual production',
            color: '#835fc1',
            tooltip: {
              valueSuffix: ' kWH'
            }
          },
          {
            data: [],
            name: 'Forecast',
            color: '#019de7',
            tooltip: {
              valueSuffix: ' kWH'
            }
          }
        ],
        tooltip: {
          dateTimeLabelFormats: {
            millisecond: '%A, %b %e'
          }
        }
      }
    }
  },
  created () {
    let id = this.$route.params.id
    let _this = this

    this.$store.dispatch('station/findOne', id).then((station) => {
      _this.breadcrumbsData = [
        {
          url: '/station-view/' + station.id,
          title: station.title
        },
        {
          url: '#',
          title: station.title + ' (Analytics)'
        }
      ]

      stationApi.forecastComparison(id).then((r) => {
        _this.values = r.data

        _this.values.forEach((value) => {
          let time = moment(value[0]).add(3, 'hours')
          _this.chartOptions.series[0].data.push([time.valueOf(), value[1][1]])
          _this.chartOptions.series[1].data.push([time.valueOf(), value[1][0]])
        })

        _this.haveData = true
      })
    })
  },
  methods: {
    toggleClass () {
      if (window.innerWidth <= 992) {
        this.isActive = !this.isActive
      }
    },
    dateShift (date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').add(1, 'hours').format('DD-MM-YY HH:mm:ss')
    },
    zeroToDash (value) {
      if (value === 0) {
        return ' -- '
      } else {
        return value
      }
    },
    downloadCSV () {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += 'Time,Actual kWH, Forecast kWH' + '\r\n'

      this.tableData.forEach(function (data) {
        let row = data.time + ',' + data.actual + ',' + data.forecast
        csvContent += row + '\r\n'
      })

      let encodedUri = encodeURI(csvContent)
      let link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'forecast.csv')
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    downloadXML () {
      let xmltext = '<?xml version="1.1" encoding="UTF-8" ?><values>'

      this.tableData.forEach(function (data) {
        let row = `<value><time>${data.time}</time><actual>${data.actual}</actual><forecast>${data.forecast}</forecast></value>`
        xmltext += row
      })

      xmltext += '</values>'

      let filename = 'forecast.xml'
      let pom = document.createElement('a')
      let bb = new Blob([xmltext], { type: 'text/plain' })

      pom.setAttribute('href', window.URL.createObjectURL(bb))
      pom.setAttribute('download', filename)

      pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':')
      pom.draggable = true
      pom.classList.add('dragout')

      pom.click()
    }
  },
  computed: {
    tableData () {
      let result = []
      const _this = this
      let prev = {
        actual: 0,
        forecast: 0,
        time: null,
        flush (newTime) {
          _this.time = newTime
          _this.forecast = 0
          _this.actual = 0
        }
      }

      let canStart = false

      this.values.forEach((data) => {
        let time = moment(data[0])

        canStart = canStart || (time.add(2, 'hours').format('HH:mm:ss') === '00:00:00')

        if (((data[1][1] !== 0) || (data[1][0] !== 0)) && canStart) {
          if ((prev.time !== null) && (prev.time.format('DD') !== time.format('DD'))) {
            let day = {
              time: prev.time.format('DD-MM-YY'),
              actual: (Math.round(prev.actual * 100) / 100),
              forecast: (Math.round(prev.forecast * 100) / 100),
              percent: Math.abs(Math.round(((prev.forecast - prev.actual) / prev.actual) * 10000) / 100),
              isDay: true
            }
            result.push(day)
            prev.flush(time)
          }

          prev.time = time
          prev.actual += data[1][1]
          prev.forecast += data[1][0]

          let value = {
            time: this.dateShift(data[0]),
            actual: this.zeroToDash(data[1][1]),
            forecast: this.zeroToDash(data[1][0]),
            isDay: false
          }

          if ((data[1][1] !== 0) && (data[1][0] !== 0)) {
            value.percent = Math.abs(Math.round(((data[1][0] - data[1][1]) / data[1][1]) * 10000) / 100)
          } else {
            value.percent = ' -- '
          }

          result.push(value)
        }
      })

      return result
    }
  }
}
</script>
